module.exports = __webpack_public_path__ + "img/careerlogo.316b97a2.svg";